<template>
	<div
		:class="{
			[$style['md-switch-container']]: true,
			[$style['md-switch-container--checked']]: value,
			[$style['md-switch-container--disabled']]: disabled
		}"
		@click="toggleSwitch"
	>
		<div :class="$style['md-switch-track']" />
		<div :class="$style['md-switch-handle']" />
	</div>
</template>
<script>

export default {
	name: 'BaseSwitch',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggleSwitch () {
			if (!this.disabled) {
				this.$emit('input', !this.value)
			}
		}
	}
}
</script>
<style lang="scss" module>
$switch-track-width: 40px;
$switch-track-height: 20px;
$switch-handle-diameter: 18px;

$duration: 100ms;

@mixin md-transition {
    transition: all $duration linear;
}

.md-switch-container {
    height: $switch-handle-diameter;
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    &--checked {
        .md-switch-track {
            background: getColor(success);
        }

        .md-switch-handle {
            left: $switch-track-width - $switch-handle-diameter - 1;
        }
    }

    &--disabled {
        pointer-events: none;
        opacity: 0.4;
    }
}

.md-switch-track {
    width: $switch-track-width;
    height: $switch-track-height;
    border-radius: $switch-track-width;
    background: getColor(switch-track);

    @include md-transition;
}

.md-switch-handle {
    width: $switch-handle-diameter;
    height: $switch-handle-diameter;
    position: absolute;
    left: 1px;
    border-radius: 100%;
    background-color: getColor(white);
    box-shadow:
        0 1px 3px 0 getColor(shadow-light),
        0 1px 1px 0 getColor(shadow),
        0 2px 1px -1px getColor(shadow-dark);

    @include md-transition;
}

.md-switch-label {
    margin-left: 10px;
    user-select: none;
    color: getColor(text);
}
</style>
